import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeWithPreviewOnlyImages } from '../../actions/publish';
import { Button } from '../../styled-components';
import { MainContent } from '../../styled-components/Layout';
import localize from '../../util/localizeUtils';
import { ButtonContainer, TabContentContainer } from './styled-components';

function RadioButton({ checked, text, value, onChange }) {
  return (
    <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'flex-end', marginTop: '16px', width: '300px' }}>
      <span style={{ paddingRight: '16px' }}>{text}</span>
      <input type="radio" checked={checked} value={value} onChange={onChange} />
    </div>
  );
}

RadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

class SaveImageToDiskTabContent extends React.PureComponent {
  onChangeWithPreviewOnlyImages = event => {
    this.props.onChangeWithPreviewOnlyImages(event.target.value);
  };

  render() {
    return (
      <TabContentContainer>
        <MainContent>
          <RadioButton checked={this.props.withPreviewOnlyImages} text={localize('withPreviewOnlyOption')} value="true" onChange={this.onChangeWithPreviewOnlyImages} />
          <RadioButton checked={!this.props.withPreviewOnlyImages} text={localize('withoutPreviewOnlyOption')} value="false" onChange={this.onChangeWithPreviewOnlyImages} />
        </MainContent>
        <ButtonContainer paddingTop="8px">
          <Button onClick={this.props.onDownload}>{localize('downloadButton')}</Button>
        </ButtonContainer>
      </TabContentContainer>
    );
  }
}

SaveImageToDiskTabContent.propTypes = {
  withPreviewOnlyImages: PropTypes.bool.isRequired,
  onChangeWithPreviewOnlyImages: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  withPreviewOnlyImages: state.publish.withPreviewOnlyImages
});

const mapDispatchToProps = dispatch => ({
  onChangeWithPreviewOnlyImages: (withPreviewOnlyImages) => {
    dispatch(changeWithPreviewOnlyImages(withPreviewOnlyImages));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SaveImageToDiskTabContent);



// WEBPACK FOOTER //
// ./app/components/RenderMediaDialog/SaveImageToDiskTabContent.js